export enum ChatSocketType {
	NewMessage = 'new_message',
	UpdateMessage = 'update_message',
	DeleteMessage = 'delete_message',
	SetUserTimeOut = 'set_user_timeout',
	SetChatStatus = 'set_chat_status',
	Reactions = 'reactions',
}
